export default __webpack_public_path__ + "static/illustration-business.url-5546976b9cd157b586b794c8721fb9ea.svg";